import {ReactNode, createElement, Fragment} from "react"
import {useMediaQuery} from "react-responsive"


export enum ScreenSize { LARGE, SMALL }

const breakpoints: Record<string, number> = {
    mobilePortrait: 600,    // max width for portrait phones
    mobileLandscape: 1000,  // max width for landscape phones
    desktop: 1000           // min width for desktop
}

type MediaProps = {
    greaterThanOrEqual?: keyof typeof breakpoints
    lessThan?: keyof typeof breakpoints
    children: ReactNode
    className?: string
    [key: string]: any
}

export const MediaContextProvider = ({ children }: { children: ReactNode }) => {
    return createElement(Fragment, null, children)
}

/**
 * Media component using React Responsive.
 */
export const Media = ({ greaterThanOrEqual, lessThan, children, className, ...rest }: MediaProps) => {
    let query: any = { minWidth: 0 }
    // <600: mobile portrait
    if (lessThan === "mobilePortrait")
        query = { query: `(max-width: ${breakpoints.mobilePortrait - 1}px) and (orientation: portrait)` }
    // 600–1000: mobile landscape (any orientation)
    else if (greaterThanOrEqual === "mobilePortrait" && lessThan === "mobileLandscape")
        query = { query: `(min-width: ${breakpoints.mobilePortrait}px) and (max-width: ${breakpoints.mobileLandscape - 1}px)` }
    // ≥1000: desktop
    else if (greaterThanOrEqual === "desktop")
        query = { query: `(min-width: ${breakpoints.desktop}px)` }

    const matches = useMediaQuery(query)
    return !matches ? null : (className || Object.keys(rest).length)
        ? createElement("div", { className, ...rest }, children)
        : createElement(Fragment, null, children)
}